import { PLATFORM_OPTIONS } from "../constants";

export type InterviewDetailsType = {
	title: string;
	candidateName: string;
	candidateEmail: string;
	positionName: string;
	interviewerUuids: string[];
	startTime: Date;
	endTime: Date;
};

export type InterviewDetailsErrorsType = {
	[K in keyof InterviewDetailsType]: string;
};

export type InterviewDetailsValidatorsType = {
	[K in keyof InterviewDetailsType]: (value: InterviewDetailsType[K]) => string;
};

export type ConferencePlatformType = {
	videoPlatform: (typeof PLATFORM_OPTIONS)[number]["value"] | null;
	meetingLink: string;
	notes: string;
};

export type ConferencePlatformErrorsType = {
	[K in keyof ConferencePlatformType]: string;
};

export type ConferencePlatformValidatorsType = {
	[K in keyof ConferencePlatformType]: (value: ConferencePlatformType[K]) => string;
};

export type Forms = InterviewDetailsType | ConferencePlatformType;

//TEMP
export function buildEmptyValidator<T extends object>(obj: T): { [K in keyof T]: () => string } {
	const result = {} as { [K in keyof T]: () => string };

	for (const key in obj) {
		result[key] = () => "";
	}

	return result;
}
